import { useTranslation } from 'react-i18next';
import { Button } from '../../UI/base/Button';
import styles from '../../../pages/TreatmentPlanBuilderPage.module.css';

export type BuilderStatus = {
  messageKey: string;
  hasBackButton: boolean;
};

interface BuilderStatusScreenProps {
  status: BuilderStatus;
  onBack: () => void;
}

export const BuilderStatusScreen = ({ status, onBack }: BuilderStatusScreenProps) => {
  const { t } = useTranslation();

  return (
    <main className={styles.page}>
      <p className={styles.statusMessage}>{t(status.messageKey)}</p>
      {status.hasBackButton && (
        <Button type="secondary" onClick={onBack}>
          {t('config-builder-back')}
        </Button>
      )}
    </main>
  );
};
